import { PatientsService } from 'infra/services/patients-service'
import { makeAxiosHttpClient } from '../http/axios-http-client-factory'

export const makePatientsService = () => new PatientsService(makeAxiosHttpClient())
